
import {ActionTypes, CCAuthorizedAxios} from './../../cc-imports'


const Actions = {
    getReward: (authDetails, rewardId, type)=> {
        return {
            type: ActionTypes.GET_REWARD,
            payload: CCAuthorizedAxios(authDetails).get('/reward/rewardId/' + rewardId + '/'),
            meta : {
                type : type
            }
        }
    },
    claimReward: (authDetails, reward, type)=> {
        return {
            type: ActionTypes.UPDATE_REWARD_CLAIM,
            payload: CCAuthorizedAxios(authDetails).post('/reward/claim/', reward),
            meta : {
                type : type
            }
        }
    },
    updateClaimReward: (authDetails, reward, type)=> {
        return {
            type: ActionTypes.UPDATE_REWARD_CLAIM,
            payload: CCAuthorizedAxios(authDetails).post('/reward/claim/update/', reward),
            meta : {
                type : type
            }
        }
    },
};

export default Actions



// WEBPACK FOOTER //
// ./src/app/data/actions/RewardActions.js